import React, { ReactElement, useLayoutEffect, useState } from 'react';

import { ScrollbarIndicator } from '@/lib/util';

import { ChoiceDataType, ChoiceOptionType } from '@/modules/types/choice';
import ChoiceOption from '@/components/ChoiceOption';

import './SingleChoice.scss';

const SingleChoice = ({
  choices,
  isDisabled,
  handler,
}: {
  choices: ChoiceOptionType[];
  isDisabled: boolean;
  handler: (answer: string) => void;
}): ReactElement => {
  const [answer, setAnswer] = useState<any>('');
  const selectChoice = (choice: ChoiceDataType) => {
    const useUUID = choice.choiceMetadata?.useUUID || false;
    const selectedChoice =
      choice.lcmsReferenceIds === undefined ||
      Object.keys(choice.lcmsReferenceIds).length <= 0 ||
      useUUID
        ? choice.id
        : choice.lcmsReferenceIds.id;

    setAnswer(selectedChoice);
  };
  useLayoutEffect(() => {
    if (answer !== '') handler(answer);
  }, [answer]);
  return (
    <div id="SingleChoice">
      <div className="singlechoice-wrapper" ref={ScrollbarIndicator()}>
        {choices.map((item: ChoiceOptionType, index: number) => (
          <ChoiceOption
            key={index}
            icon={item.option}
            iconRight={false}
            title=""
            description={item.data.content}
            onClick={() => {
              selectChoice(item.data);
            }}
            isDisabled={isDisabled}
          />
        ))}
      </div>
    </div>
  );
};

export default SingleChoice;
